<template>
<modal :showCloseButton="true">
    <span slot="heading">
        Register guest
    </span>
    <span slot="description">
        <span v-if="rawMenu.user.guest_register_description">{{rawMenu.user.guest_register_description}}</span>
        <span v-else>If you are dining in, please enter your details to help with contact tracing.</span>
    </span>
    <div slot="content">
        <div v-if="!dineInIntent">

            <button class="btn btn-primary btn-md btn-block " v-on:click="closeModals()">
                Just the menu
            </button>
            <button v-if="!dineInIntent" class="btn btn-primary btn-md btn-block " v-on:click="$emit('dine-in-intent', true)">
                Dine-in Register
            </button>
        </div>
        <form class="mt-3 animate__animated animate__fadeIn animate__delay-1s" v-on:submit.prevent="onSubmit" v-if="dineInIntent">
            <div class="form-group">
                <label for="first_name">First Name</label>
                <input v-model="first_name" type="text" class="form-control form-control-sm" id="first_name" v-bind:class="{ 'is-invalid': errors.first_name }" required />
                <small v-if="errors.first_name" class="text-danger">{{
                            errors.first_name
                        }}</small>
            </div>
            <div class="form-group">
                <label for="last_name">Last Name</label>
                <input v-model="last_name" type="text" class="form-control form-control-sm" id="last_name" v-bind:class="{ 'is-invalid': errors.last_name }" required />
                <small v-if="errors.last_name" class="text-danger">{{
                            errors.last_name
                        }}</small>
            </div>
            <div class="form-group">
                <label for="mobile">Mobile Number</label>
                <input v-model="mobile" type="text" class="form-control form-control-sm" id="mobile" v-bind:class="{ 'is-invalid': errors.mobile }" required />
                <small v-if="errors.mobile" class="text-danger">{{
                            errors.mobile
                        }}</small>
            </div>

            <button type="submit" class="btn btn-primary btn-lg btn-block " v-if="!processing">
                Submit
            </button>
            <formLoader v-if="processing" class="text-center my-5"></formLoader>

        </form>
    </div>
</modal>
</template>

<style scoped></style>

<script>
import formLogo from "../form/FormLogo";
import formLoader from "../form/FormLoader";
import modal from "../shared/Modal";

export default {
    mounted() {
        this.processing = true;
        this.getGuest(this.$route.params.userSlug).then(result => {
            if (this.guest.registered) {
                this.closeModals();
            }
            this.processing = false;
        });
    },
    data() {
        return {
            first_name: null,
            last_name: null,
            mobile: null,
            processing: false
        };
    },
    methods: {
        onSubmit: function () {
            this.processing = true;
            axios
                .post("/api/guest/register", {
                    user_id: this.rawMenu.user.id,
                    first_name: this.first_name,
                    last_name: this.last_name,
                    mobile: this.mobile,
                })
                .then(
                    response => {
                        this.error = null;
                        this.getGuest(this.$route.params.userSlug).then(result => {
                            if (this.guest.registered) {
                                this.closeModals();
                            }
                            this.processing = false;
                        });
                    },
                    error => {
                        this.processing = false;
                        this.error = error;
                    }
                );
        },
    },
    components: {
        formLogo,
        formLoader,
        modal
    },
    props: ["dineInIntent"],
};
</script>
